import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="dealConfirm";

export function selectByDealId(dealId){
  return axios({
    url: `/ws/${moduleName}/selectByDealId/${dealId}`,
    method: 'get',
  })
}

export function selectByProjectId(projectId){
  return axios({
    url: `/ws/${moduleName}/selectByProjectId/${projectId}`,
    method: 'get',
  })
}

export function findProprietor(dealConfrimId){
  return axios({
    url: `/ws/${moduleName}/findProprietor/${dealConfrimId}`,
    method: 'get',
  })
}

export function selectDealConfirmVOByDealId(dealId){
  return axios({
    url: `/ws/${moduleName}/selectDealConfirmVOByDealId/${dealId}`,
    method: 'get',
  })
}

export function selectDealConfirmVOByProjectId(dealId){
  return axios({
    url: `/ws/${moduleName}/selectDealConfirmVOByProjectId/${dealId}`,
    method: 'get',
  })
}

export function selectOne(parameter){
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get',
  })
}

export function getFindCompanyInfo(){
  return axios({
    url: `/ws/${moduleName}/getFindCompanyInfo`,
    method: 'get',
  })
}

export function insert(parameter){
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function selectAllByPage(parameter){
  console.log("dealConfirm : ",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function dealConfirmStatistic(){
  return axios({
    url: `/ws/${moduleName}/dealConfirmStatistic`,
    method: 'get'
  })
}


/**
 * 查询所有分过佣金的人员信息
 * @param parameter
 */
export function selectAllUsers(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllUsers`,
    method: 'get',
    params: parameter
  })
}


export function rejectDealConfirm(parameter){
  return axios({
    url: `/ws/${moduleName}/rejectDealConfirm`,
    method: 'put',
    data: parameter,
  })
}
export function financeRejectDealConfirm(parameter){
  return axios({
    url: `/ws/${moduleName}/financeRejectDealConfirm`,
    method: 'put',
    data: parameter,
  })
}


export function notConfirmList(parameter){
  return axios({
    url: `/ws/${moduleName}/notConfirmList`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function dealConfirmPartake(parameter,comment,dealConfirmId){
  return axios({
    url: `/ws/${moduleName}/dealConfirmPartake/${parameter}/${comment}/${dealConfirmId}`,
    method: 'put',
  })
}
export function updateDealConfirmLease(parameter){
  return axios({
    url: `/ws/${moduleName}/updateDealConfirmLease`,
    method: 'post',
    data:parameter
  })
}

// export function deleteAgencyAgreement(parameter){
//   return axios({
//     url: `/ws/${moduleName}/deleteAgencyAgreement/${parameter}`,
//     method: 'delete',
//     data:parameter
//   })
// }


export function cancelDealConfirm(parameter){
  return axios({
    url: `/ws/${moduleName}/cancelDealConfirm/${parameter}`,
    method: 'delete',
    data:parameter
  })
}

export function addPaid(dealConfirm){
  console.log("dealConfirm : ",dealConfirm)
  return axios({
    url: `/ws/${moduleName}/addPaid`,
    method: 'put',
    data:dealConfirm,
  })
}

export function resetTaxRate(dealConfrimId,taxRate){
  return axios({
    url: `/ws/${moduleName}/resetTaxRate/${dealConfrimId}/${taxRate}`,
    method: 'put',
  })
}

export function financeConfirm(parameter,frozen){
  console.log("dealConfirm : ",parameter)
  return axios({
    url: `/ws/${moduleName}/financeConfirm/${parameter}`,
    method: 'put',
    params: frozen,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function freezeCommission(parameter){
  console.log("dealConfirm : ",parameter)
  return axios({
    url: `/ws/${moduleName}/freezeCommission/`,
    method: 'put',
    data: parameter,
  })
}
export function changeAgencyAgreement(parameter){
  console.log("dealConfirm : ",parameter)
  return axios({
    url: `/ws/${moduleName}/changeAgencyAgreement`,
    method: 'put',
    data: parameter,
  })
}

export function approveDeal(parameter){
  console.log("dealConfirm : ",parameter)
  return axios({
    url: `/ws/${moduleName}/approveDeal`,
    method: 'put',
    data: parameter,
  })
}

export function exprotAllByParam(parameter){
  console.log("dealConfirm : ",parameter)
  return axios({
    url: `/ws/${moduleName}/exprotAllByParam`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    responseType:'blob'
  })
}



export function selectBeOverdueAll() {
  return axios({
    url: `/ws/${moduleName}/selectBeOverdueAll`,
    method: 'get',
  })
}



export function selectBeOverdueAllExpiringSoon() {
  return axios({
    url: `/ws/${moduleName}/selectBeOverdueAllExpiringSoon`,
    method: 'get',
  })
}


export function selectBeOverdueAllLeader() {
  return axios({
    url: `/ws/${moduleName}/selectBeOverdueAllLeader`,
    method: 'get',
  })
}


export function selectBeOverdueAllExpiringSoonLeader() {
  return axios({
    url: `/ws/${moduleName}/selectBeOverdueAllExpiringSoonLeader`,
    method: 'get',
  })
}


export function batchUpdateEndTime(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/batchUpdateEndTime`,
    method: 'put',
    data:parameter
  })
}





export default {
  selectByDealId,
  selectByProjectId,
  approveDeal,
  insert,
  selectAllByPage,
  findProprietor,
  selectOne,
  selectAllUsers,
  exprotAllByParam,
  // updateDealConfirmPartake,
  // updateDealConfirmDetails,
  notConfirmList,
  dealConfirmPartake,
  updateDealConfirmLease,
  // deleteAgencyAgreement,
  resetTaxRate,
  cancelDealConfirm,
  getFindCompanyInfo,
  selectDealConfirmVOByDealId,
  selectDealConfirmVOByProjectId,
  selectBeOverdueAllExpiringSoon,
  addPaid,
  financeConfirm,
  freezeCommission,
  changeAgencyAgreement,
  dealConfirmStatistic,
  rejectDealConfirm,
  financeRejectDealConfirm,
  batchUpdateEndTime,
  selectBeOverdueAll,
  selectBeOverdueAllLeader,
  selectBeOverdueAllExpiringSoonLeader
}